import request from '@/assets/util/request'   //ajax请求

export const newList = (data)=> {
    return request({
        url: `/agent/api/new/list/${data.type}`,
        method: 'get',
        data: data,
        params: data
    })

}
